export default "__VITE_ASSET__BTsGQinO__"